const tokenTypes = {
  ACCESS: "access",
  REFRESH: "refresh",
  RESET_PASSWORD: "resetPassword",
  VERIFY_EMAIL: "verifyEmail",
};

const rolesTypes = {
  ADMIN: 1,
  SEEKER: 2,
  OWNER: 3,
  SERVICE: 4,
  GUEST: 5,
};

const permissionTypes = {
  READ: 1,
  WRITE: 2,
  UPDATE: 3,
  DELETE: 4,
};

const loginTypes = {
  EMAIL: 1,
  PHONE: 2,
  GOOGLE: 3,
  FACEBOOK: 4,
  GUEST: 5,
};

const userStatus = {
  PENDING: 0,
  SUCCESS: 1,
  DEACTIVE: 2,
};

const otpTypes = {
  REGISTRATION: 1,   // OTP sent during user registration
  LOGIN: 2,          // OTP sent for user login
  PASSWORD_RESET: 3, // OTP sent for password reset
  EMAIL_VERIFICATION: 4, // OTP sent for email verification
  PHONE_VERIFICATION: 5 // OTP sent for phone number verification
};


const deviceTypes = {
  MOBILE: 1,
  TABLET: 2,
  DESKTOP: 3,
  OTHER: 4,

};

module.exports = {
  tokenTypes,
  rolesTypes,
  permissionTypes,
  userStatus,
  loginTypes,
  otpTypes,
  deviceTypes
};
